// src/hooks/useMasterOptions.ts
import { useEffect, useState } from 'react';
import { fetchRolesMasterData, fetchExpenseCategoryCombinations } from '../api/accountsApi';
import { MasterDataItem, Option } from '../types/common.types';

export const useRoleOptions = () => {
  const [options, setOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try { 
        const res = await fetchRolesMasterData(); 
        const list = res?.data || [];  
        const mapped = list.map((item: MasterDataItem) => ({
          label: item.value,
          value: item.key,
        }));
    
        setOptions(mapped);
      } catch (err) {
        console.error('Failed to load role options', err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return { options, loading };
};

export const useCategoryOptions = () => {
  const [options, setOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try { 
        const res = await fetchExpenseCategoryCombinations(); 
        const list = res?.data?.data || [];  
        const mapped = list.map((item: string) => ({
          label: item,
          value: item,
        }));
    
        setOptions(mapped);
      } catch (err) {
        console.error('Failed to load category options', err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return { options, loading };
};
